import { useMemo, useState } from "react";
import {
  FaWhatsapp,
  FaSearch,
  FaInbox,
  FaUserClock,
  FaUsers,
  FaChartLine,
  FaSyncAlt,
  FaCog,
} from "react-icons/fa";

import Sidebar from "./Sidebar";
import QueueList from "./QueueList";
import ChatPanel from "./ChatPanel";
import LeadDetails from "./LeadDetails";

export default function ChatPage({
  minhasConversas = [],
  filaDeEspera = [],
  contatos = [],
  empresaId,
}) {
  const [canalSelecionado, setCanalSelecionado] = useState("whatsapp");
  const [conversaSelecionada, setConversaSelecionada] = useState(null);
  const [busca, setBusca] = useState("");

  const totalMinhasConversas = minhasConversas.length;
  const totalFila = filaDeEspera.length;
  const totalContatos = contatos.length;

  const conversasFiltradas = useMemo(() => {
    const normalizar = (valor) =>
      String(valor || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    const termo = normalizar(busca);

    const filtrarLista = (lista) => {
      return lista.filter((item) => {
        const pertenceCanal =
          !canalSelecionado || item.canal === canalSelecionado;

        const bateBusca =
          !termo ||
          normalizar(item.nome).includes(termo) ||
          normalizar(item.numero).includes(termo) ||
          normalizar(item.preview).includes(termo) ||
          normalizar(item.status).includes(termo);

        return pertenceCanal && bateBusca;
      });
    };

    return {
      minhasConversas: filtrarLista(minhasConversas),
      filaDeEspera: filtrarLista(filaDeEspera),
      contatos: filtrarLista(contatos),
    };
  }, [busca, canalSelecionado, minhasConversas, filaDeEspera, contatos]);

  const handleEnviarMensagem = async (texto, conversa) => {
    if (!conversa || !texto?.trim()) return;

    console.log("Enviar mensagem Captazap:", {
      conversaId: conversa.id,
      telefone: conversa.numero,
      canal: conversa.canal,
      texto,
    });

    // Integração futura:
    // await captazapApi.enviarMensagem({
    //   conversaId: conversa.id,
    //   telefone: conversa.numero,
    //   texto,
    // });
  };

  const handleConverterLead = async (conversa) => {
    console.log("Converter conversa em lead:", conversa);

    // Integração futura:
    // await captazapApi.converterConversaEmLead({
    //   conversaId: conversa.id,
    //   nome: conversa.nome,
    //   telefone: conversa.numero,
    //   origem: conversa.origem || "WhatsApp",
    // });
  };

  const handleAgendarTarefa = (conversa) => {
    console.log("Agendar tarefa:", conversa);
  };

  const handleAdicionarTag = (conversa) => {
    console.log("Adicionar tag:", conversa);
  };

  const handleVincularLead = (conversa) => {
    console.log("Abrir lead vinculado:", conversa.lead_id || conversa.leadId);
  };

  return (
    <div className="h-screen w-full overflow-hidden bg-slate-100 text-slate-900">
      <div className="flex h-full">
        <Sidebar
          canalSelecionado={canalSelecionado}
          setCanalSelecionado={setCanalSelecionado}
        />

        <div className="flex min-w-0 flex-1 flex-col">
          <HeaderCaptazap
            busca={busca}
            onBuscaChange={setBusca}
            canalSelecionado={canalSelecionado}
            totalMinhasConversas={totalMinhasConversas}
            totalFila={totalFila}
            totalContatos={totalContatos}
          />

          <div className="flex min-h-0 flex-1">
            <aside className="hidden w-[380px] shrink-0 border-r border-slate-200 bg-white xl:block">
              <QueueList
                minhasConversas={conversasFiltradas.minhasConversas}
                filaDeEspera={conversasFiltradas.filaDeEspera}
                contatos={conversasFiltradas.contatos}
                conversaSelecionada={conversaSelecionada}
                onSelectConversa={setConversaSelecionada}
              />
            </aside>

            <main className="min-w-0 flex-1 bg-slate-50">
              {conversaSelecionada ? (
                <ChatPanel
                  conversa={conversaSelecionada}
                  onSend={handleEnviarMensagem}
                />
              ) : (
                <EmptyConversationState />
              )}
            </main>

            <aside className="hidden w-[360px] shrink-0 border-l border-slate-200 bg-white 2xl:block">
              <LeadDetails
                conversa={conversaSelecionada}
                empresaId={empresaId}
                onConverterLead={handleConverterLead}
                onAgendarTarefa={handleAgendarTarefa}
                onAdicionarTag={handleAdicionarTag}
                onVincularLead={handleVincularLead}
              />
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}

function HeaderCaptazap({
  busca,
  onBuscaChange,
  canalSelecionado,
  totalMinhasConversas,
  totalFila,
  totalContatos,
}) {
  return (
    <header className="shrink-0 border-b border-slate-200 bg-white/95 px-5 py-3 shadow-sm backdrop-blur-xl">
      <div className="flex items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600 ring-1 ring-emerald-100">
            <FaWhatsapp size={22} />
          </div>

          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <h1 className="truncate text-lg font-semibold tracking-tight text-slate-950">
                Captazap
              </h1>

              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium capitalize text-slate-500">
                {canalSelecionado || "Todos os canais"}
              </span>
            </div>

            <p className="truncate text-sm text-slate-500">
              Atendimento, conversas e geração de leads via WhatsApp
            </p>
          </div>
        </div>

        <div className="hidden min-w-[320px] max-w-[480px] flex-1 md:block">
          <div className="relative">
            <FaSearch
              className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              size={14}
            />

            <input
              value={busca}
              onChange={(event) => onBuscaChange(event.target.value)}
              placeholder="Buscar por nome, telefone, mensagem ou status"
              className="h-10 w-full rounded-xl border border-slate-200 bg-slate-50 pl-10 pr-3 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-500/10"
            />
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <MetricPill
            icon={<FaInbox />}
            label="Minhas"
            value={totalMinhasConversas}
          />

          <MetricPill
            icon={<FaUserClock />}
            label="Fila"
            value={totalFila}
            highlight={totalFila > 0}
          />

          <MetricPill
            icon={<FaUsers />}
            label="Contatos"
            value={totalContatos}
          />

          <button
            type="button"
            className="hidden h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:bg-slate-50 hover:text-slate-900 lg:flex"
            title="Atualizar"
          >
            <FaSyncAlt size={14} />
          </button>

          <button
            type="button"
            className="hidden h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 transition hover:bg-slate-50 hover:text-slate-900 lg:flex"
            title="Configurações"
          >
            <FaCog size={14} />
          </button>
        </div>
      </div>

      <div className="mt-3 block md:hidden">
        <div className="relative">
          <FaSearch
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
            size={14}
          />

          <input
            value={busca}
            onChange={(event) => onBuscaChange(event.target.value)}
            placeholder="Buscar conversas"
            className="h-10 w-full rounded-xl border border-slate-200 bg-slate-50 pl-10 pr-3 text-sm text-slate-800 outline-none transition focus:border-blue-400 focus:bg-white focus:ring-4 focus:ring-blue-500/10"
          />
        </div>
      </div>
    </header>
  );
}

function MetricPill({ icon, label, value, highlight = false }) {
  return (
    <div
      className={`hidden items-center gap-2 rounded-xl border px-3 py-2 text-sm lg:flex ${
        highlight
          ? "border-amber-200 bg-amber-50 text-amber-700"
          : "border-slate-200 bg-white text-slate-600"
      }`}
    >
      <span className={highlight ? "text-amber-600" : "text-slate-400"}>
        {icon}
      </span>

      <span className="font-medium">{label}</span>

      <span
        className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
          highlight
            ? "bg-amber-100 text-amber-700"
            : "bg-slate-100 text-slate-600"
        }`}
      >
        {value}
      </span>
    </div>
  );
}

function EmptyConversationState() {
  return (
    <div className="flex h-full items-center justify-center px-8">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-3xl bg-blue-50 text-blue-600 ring-1 ring-blue-100">
          <FaChartLine size={28} />
        </div>

        <h2 className="text-xl font-semibold tracking-tight text-slate-950">
          Selecione uma conversa
        </h2>

        <p className="mt-2 text-sm leading-6 text-slate-500">
          Escolha um atendimento na fila, em suas conversas ou na lista de
          contatos para visualizar o histórico, responder mensagens e gerar
          leads no Captacrm.
        </p>

        <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-4 text-left shadow-sm">
          <div className="text-sm font-semibold text-slate-800">
            Fluxo recomendado
          </div>

          <div className="mt-3 space-y-3 text-sm text-slate-500">
            <div className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600">
                1
              </span>
              <span>Assuma uma conversa da fila de espera.</span>
            </div>

            <div className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600">
                2
              </span>
              <span>Converse com o contato e qualifique a oportunidade.</span>
            </div>

            <div className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-semibold text-slate-600">
                3
              </span>
              <span>Converta a conversa em lead dentro do Captacrm.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
